import React from 'react'
import { AppBar, IconButton, Toolbar, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { gradientColors } from '../../Color/Color'

interface FullScreenDialogHeaderProps {
  hasCloseBtn?: boolean
  customHeaderStyle?: React.CSSProperties
  headerContent?: React.ReactNode
  onHide: () => void
}

const FullScreenDialogHeader: React.FC<FullScreenDialogHeaderProps> = ({
  hasCloseBtn,
  customHeaderStyle,
  headerContent,
  onHide,
}) => {
  return (
    <AppBar
      position='sticky'
      sx={{
        position: 'sticky',
        background: gradientColors.greenGradient,
        ...customHeaderStyle,
      }}
    >
      <Toolbar>
        <Box sx={{ flex: 1 }}>{headerContent}</Box>

        {hasCloseBtn && (
          <IconButton edge='start' color='inherit' onClick={onHide} aria-label='close'>
            <CloseIcon />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default FullScreenDialogHeader
